import { getInformalName } from './name-utils'
import { trackImpression, trackLinkWithData } from 'lib/analytics/fpti'
import { tracking as mParticleTracking } from 'lib/analytics/mParticle'
import content from 'pp-react-l10n'
const i18n = content('transfer/24-hour-holds/index')

// https://www.msmaster.qa.paypal.com/elmo/experiment/103853
// These are the experiment/treatments, although we defer the ELMO call to services
export const VARIANTS = {
  GENERIC: 'RISK_24_HOUR_HOLDS_GENERIC',
  SECURITY: 'RISK_24_HOUR_HOLDS_SECURITY',
  ACCOUNT_TAKEOVER: 'RISK_24_HOUR_HOLDS_ACCOUNT_TAKEOVER',
  ACCOUNT_TAKEOVER_WITH_AVATAR:
    'RISK_24_HOUR_HOLDS_ACCOUNT_TAKEOVER_WITH_AVATAR',
}

// Based upon confluence page:-
// https://engineering.paypalcorp.com/confluence/display/MUSIC/P2P+%7C+24+Hr+Hold
const PAGE_NAME = 'main:p2p:sendmoney:submit:riskhold::'
const PAGE_GROUP = 'main:p2p:sendmoney:submit:riskhold'

export function trackRiskHoldImpression({
  additionalDisclosureActions = [],
  riskHoldOverpanelVariant = '',
}) {
  const trackingData = {
    action: additionalDisclosureActions.join(', '),
    page_variant: riskHoldOverpanelVariant,
  }
  trackImpression(PAGE_GROUP, PAGE_NAME, trackingData)
  mParticleTracking('24_hr_hold_screen_shown', 'im', trackingData)
}

export function trackButtonClick(buttonName = 'continue', overpanelVariant) {
  const trackingData = {
    page_variant: overpanelVariant,
  }
  const eventName = `24_hr_hold_${buttonName}_pressed`
  trackLinkWithData(buttonName, PAGE_GROUP, PAGE_NAME, {}, 'link', {})
  mParticleTracking(eventName, 'cl', trackingData)
}

export function hasTwentyFourHourHoldsVariant(overpanelVariant = '') {
  for (let key in VARIANTS) {
    if (overpanelVariant === VARIANTS[key]) {
      return true
    }
  }
  return false
}

export function getHeaderContent({ variant = '', name = '' }) {
  switch (variant) {
    // Design change - the generic variant now uses account takeover header
    case VARIANTS.GENERIC:
    case VARIANTS.ACCOUNT_TAKEOVER:
      return i18n('header.accountTakeover', { name })
    // All other variants will use old generic header
    default:
      return i18n('header.generic', { name })
  }
}

// Get respective paragraph content depending on variant
export function getParagraphContent({
  variant = '',
  firstName: givenName = '',
  lastName: surname = '',
  displayName = '',
  recipient = '',
  country = '',
}) {
  const informalName =
    getInformalName({ givenName, surname, country }) ||
    displayName ||
    recipient ||
    i18n('paragraph.they')
  switch (variant) {
    case VARIANTS.ACCOUNT_TAKEOVER_WITH_AVATAR:
      return i18n('paragraph.security', { informalName })
    case VARIANTS.SECURITY:
      return i18n('paragraph.noDuration', { name: informalName })
    default:
      return i18n('paragraph.accountTakeover', { informalName })
  }
}
